import React from "react";
import { Button } from "react-bootstrap";
import { FaIcon } from "lib/FaIcon";
import { NomuraLogo } from "pages/login/NomuraLogo";
import { classes } from "./getAdvertStyles";

export const SmallWhiteNomuraLogo = ({ nomuraLogo }) =>
  nomuraLogo ? (
    <header className="border-bottom-0 p-0 pb-0 ">
      <NomuraLogo className="bg-transparent mx-0" styles={{ fill: nomuraLogo, maxWidth: "100px", maxHeight: "25px" }} />
    </header>
  ) : null;

export const Heading = ({ heading, styles }) => (
  <header className={styles.heading || styles.header} style={styles.headingStyle}>
    {heading}
  </header>
);

export const Title = ({ icon, title, styles }) =>
  title ? (
    <article className={`${classes.title} ${styles.title}`} style={styles.titleStyle}>
      {icon && <FaIcon icon={`${icon} ${styles.titleIcon}`} />}
      {title}
    </article>
  ) : null;

export const Text = ({ text, styles }) => (text ? <div className={styles.text}>{text}</div> : null);

export const CenterImg = ({ centerImg, styles }) =>
  centerImg ? (
    <img
      src={process.env.PUBLIC_URL + "/static/images/" + centerImg}
      className={styles.centerImg}
      style={styles.centerImgStyle}
      alt="centerImg"
    />
  ) : null;

export const Footer = ({ footer, buttonInline, styles }) =>
  footer || buttonInline ? (
    <footer className={styles.footer} style={styles.footerStyle}>
      {footer}
      {buttonInline && (
        <Button variant={styles.buttonInline} style={styles.buttonStyle}>
          {" "}
          {buttonInline}{" "}
        </Button>
      )}
    </footer>
  ) : null;

export const CenterButton = ({ button, styles }) =>
  button ? (
    <Button className={styles.button} style={styles.buttonStyle}>
      {button}
    </Button>
  ) : null;
